<div id="last_step" class="mt-3">
  <div *ngIf="pacchetto.opzioni && pacchetto.opzioni.length > 0">
    <div class="head mb-1">
      {{ "base.opzioni_winebox_label" | translate }}
    </div>
    <div
      *ngFor="let opzione of pacchetto.opzioni; let i = index"
      class="opzioni__container"
    >
      <mat-checkbox
        (change)="addOpzione(opzione)"
        class="opzione__nome"
        [(ngModel)]="opzione.selezionata"
      >
        <span class="opzione__prezzo">
          <span *ngIf="opzione.costo > 0"
            >€ {{ opzione.costo | number : "1.2-2" }}</span
          >
          <span *ngIf="opzione.costo == 0">
            {{ "base.gratis" | translate | titlecase }}
          </span>
        </span>
      </mat-checkbox>
      <span class="opzione__prezzo">
        {{ opzione.descrizione }}
      </span>
    </div>
  </div>

  <!-- <div *ngIf="tvAssociata">
    <hr class="divisore" class="divisore" />
    <div class="content__text">
      <h2 class="head">
        {{ "base.associata_title" | translate }}
      </h2>
      <div
        class="descrizione"
        [innerHTML]="'base.associata_description' | translate"
      ></div>
    </div>

    <div class="associata__flex mt-1">
      <img
        class="associata__img puntatore"
        [src]="tvAssociata.imgsrc"
        alt="Immagine copertina tipovisita {{ tvAssociata.titolo }}"
      />
      <div class="associata__content">
        <div class="associata__title puntatore under">
          {{ tvAssociata.titolo }}
        </div>
        <div class="associata__price">
          <div
            [ngClass]="
              tvAssociata.scontoAssociata > 0 ? 'underline' : 'not-underlined'
            "
            *ngIf="tvAssociata.scontoAssociata < 100"
          >
            <span class="valuta">€</span>
            <span class="base">
              {{ getCostoTipovisita(tvAssociata) | number : "1.2-2" }}
            </span>
          </div>
          <div
            *ngIf="tvAssociata.scontoAssociata > 0"
            class="not-underlined d-flex flex-column"
          >
            <div>
              <span class="scontato" *ngIf="tvAssociata.scontoAssociata < 100"
                >€</span
              >
              <span class="scontato" *ngIf="tvAssociata.scontoAssociata == 100">
                {{ "gite_extra.incluso" | translate | titlecase }}
              </span>
              <span class="scontato" *ngIf="tvAssociata.scontoAssociata < 100">
                {{
                  getCostoTipovisitaScontato(
                    tvAssociata,
                    tvAssociata.scontoAssociata
                  ) | number : "1.2-2"
                }}
              </span>
            </div>
          </div>
          <div
            class="valore-sconto"
            *ngIf="
              tvAssociata.scontoAssociata > 0 &&
              tvAssociata.scontoAssociata != 100
            "
          >
            <small>- {{ tvAssociata.scontoAssociata }}%</small>
          </div>
        </div>
        <div class="buttons__wrapper">
          <button
            class="button__add"
            (click)="settaAssociata(tvAssociata)"
            [ngClass]="tvSelezionata ? 'attivo' : 'disattivo'"
          >
            <span *ngIf="!tvSelezionata">
              {{ "base.aggiungi_voucher" | translate }}
            </span>
            <span *ngIf="tvSelezionata">
              {{ "base.aggiunto_voucher" | translate }}
            </span>
          </button>
          <span
            class="material-symbols-outlined button__delete"
            (click)="tvSelezionata = null"
            *ngIf="tvSelezionata"
          >
            delete
          </span>
        </div>
      </div>
    </div>
  </div> -->

  <app-associata-box
    [tvAssociata]="tvAssociata"
    (set)="settaAssociata($event)"
    (reset)="resettaAssociata()"
    *ngIf="tvAssociata"
  ></app-associata-box>

  <div class="row mt-5">
    <div class="col-12">
      <div class="riepilogo">
        <div class="line-head">
          <div class="head">
            {{ "base.riepilogo" | translate }}
          </div>
          <hr class="divisore" />
        </div>

        <div class="line">
          <div class="riepilogo__label nomin">
            {{ "base.qta_vino" | translate }}
          </div>
          <div class="riepilogo__total d-flex justify-content-end">
            <div
              class="input-group counter d-flex justify-content-center w-fit"
            >
              <span class="input-group-btn">
                <button
                  class="btn minus stroked-blue"
                  type="button"
                  mat-stroked-button
                  (click)="pacchettoMeno()"
                >
                  <span class="material-symbols-outlined"> remove </span>
                </button>
              </span>
              <span class="counter-item stroked-blue">{{ pacchetto.qta }}</span>
              <span class="input-group-btn">
                <button
                  class="btn plus stroked-blue"
                  type="button"
                  mat-stroked-button
                  (click)="pacchettoPiu()"
                >
                  <span class="material-symbols-outlined"> add </span>
                </button>
              </span>
            </div>
          </div>
        </div>

        <hr class="divisore" *ngIf="promoSelezionata" />

        <div class="line" *ngIf="promoSelezionata">
          <label class="riepilogo__label">
            {{ "prenotazioni.labelCodiceUsato" | translate }}
          </label>
          <div class="riepilogo__total">
            <div>
              {{ promoSelezionata.promo.titolo }}
            </div>
            <div>
              <div>
                {{ promoSelezionata.promo.codice }}
              </div>
              <div>
                <b>
                  {{ promoSelezionata.promo.codice }}
                </b>
                <b>
                  - {{ promoSelezionata.promo.tipo === "0" ? "€" : "%" }}
                  {{ promoSelezionata.promo.valore }}
                </b>
              </div>
            </div>
          </div>
        </div>
        <div
          class="line"
          *ngIf="
            promoSelezionata &&
            promoSelezionata.errore == 'promodialogo.importominimo'
          "
        >
          <label class="riepilogo__label">
            {{ "base.errore" | translate }}
          </label>
          <span class="riepilogo__total bold">
            {{ promoSelezionata.errore | translate }}
            {{
              promoSelezionata.errore == "promodialogo.importominimo"
                ? "€" + promoSelezionata.promo.minimo
                : ""
            }}
          </span>
        </div>

        <hr class="divisore" />

        <div class="line">
          <label class="riepilogo__label">
            {{ "base.totale_winebox" | translate }}
          </label>
          <span class="riepilogo__total">
            <span class="total" [ngClass]="{ barrato: promoSelezionata }">
              € {{ totalePacchetti | number : "1.2-2" }}
            </span>
            <span class="in-sconto total ml-3" *ngIf="promoSelezionata">
              € {{ totalePacchettiConPromo | number : "1.2-2" }}
            </span>
          </span>
        </div>

        <div class="line" *ngIf="tvSelezionata">
          <label class="riepilogo__label">
            {{ "base.totale_associata" | translate }}
          </label>
          <span class="riepilogo__total total">
            <span *ngIf="totaleTv > 0.0"
              >€ {{ totaleTv | number : "1.2-2" }}
            </span>
            <span *ngIf="totaleTv == 0.0">
              {{ "gite_extra.incluso" | translate | titlecase }}
            </span>
          </span>
        </div>

        <div class="line" *ngIf="tvSelezionata && !promoSelezionata">
          <label class="riepilogo__label">
            {{ "base.totale_associata_winebox" | translate }}
          </label>
          <span class="riepilogo__total total">
            € {{ totaleGenerale | number : "1.2-2" }}
          </span>
        </div>

        <div class="line" *ngIf="promoSelezionata">
          <label class="riepilogo__label">
            {{ "base.totale_finale" | translate }}
          </label>
          <span class="riepilogo__total total">
            € {{ totalescontato | number : "1.2-2" }}
          </span>
        </div>
      </div>

      <div class="flex-actions mt-2">
        <div class="input__codice__wrapper" *ngIf="!promoSelezionata">
          <mat-form-field class="input__codice" appearance="outline">
            <mat-label>
              {{ "base.codiceregalo_label" | translate }}
            </mat-label>
            <input
              matInput
              [(ngModel)]="codicePromo"
              placeholder="Es: 12-O45SS"
            />
          </mat-form-field>
          <button
            class="btn btn-green"
            (click)="riscattaCodice()"
            [disabled]="isDisabled()"
          >
            {{ "base.codiceregalo_btn" | translate }}
            <span class="material-symbols-outlined"> card_giftcard </span>
          </button>
        </div>
        <button class="btn btn-red" (click)="primoStepPagamento()">
          {{ "base.aggiungi_carrello" | translate }}
          <span class="material-symbols-outlined"> shopping_bag </span>
        </button>
      </div>
    </div>
  </div>
</div>
